import React from 'react';
import './DogeRain.css';

const DogeRain = () => {
  // Generate multiple dogecoin elements for the rain effect
  const generateCoins = (count) => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      delay: Math.random() * 5, // Random delay between 0-5 seconds
      duration: 3 + Math.random() * 4, // Random duration between 3-7 seconds
      left: Math.random() * 100, // Random horizontal position
      size: 20 + Math.random() * 15, // Random size between 20-35px
      rotation: Math.random() * 360 // Random starting rotation
    }));
  };

  const leftCoins = generateCoins(15); // 15 coins for left sidebar
  const rightCoins = generateCoins(15); // 15 coins for right sidebar

  return (
    <>
      <div className="doge-rain-sidebar doge-rain-left">
        {leftCoins.map(coin => (
          <div
            key={`left-${coin.id}`}
            className="doge-coin"
            style={{
              left: `${coin.left}%`,
              animationDelay: `${coin.delay}s`,
              animationDuration: `${coin.duration}s`,
              width: `${coin.size}px`,
              height: `${coin.size}px`,
              transform: `rotate(${coin.rotation}deg)`
            }}
          >
            <div className="coin-face">
              <div className="coin-d">Ð</div>
            </div>
          </div>
        ))}
      </div>
      <div className="doge-rain-sidebar doge-rain-right">
        {rightCoins.map(coin => (
          <div
            key={`right-${coin.id}`}
            className="doge-coin"
            style={{
              left: `${coin.left}%`,
              animationDelay: `${coin.delay}s`,
              animationDuration: `${coin.duration}s`,
              width: `${coin.size}px`,
              height: `${coin.size}px`,
              transform: `rotate(${coin.rotation}deg)`
            }}
          >
            <div className="coin-face">
              <div className="coin-d">Ð</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default DogeRain;

